<template lang="pug">
div
  index-page(@set-loading="setLoading", :parentData="{ grid, path, grid_key, report_class }")
  ui-prompts(:parentData="{ areas_key: grid }")
</template>

<script setup>
import { computed, onBeforeMount } from "vue";
import { useStore } from "@/store";
import indexPage from "../../shared/indexPage";
import uiPrompts from "../../shared/ui_prompts/index.vue";

const emit = defineEmits([
  /**
   * Используется для назначения класса на верхний оберточный div. Принимает в качесте параметров объект
   * с ключами val (boolean) и class (строка)
   */
  "expand-class",
  /**
   * Используется для изменения loading значения main компонента. Принимает в качестве параметров boolean значение
   */
  "set-loading",
]);

const store = useStore();

const grid = "buildings";
const report_class = "building";
const grid_key = "data";

const path = computed(() => store.state.paths?.building ?? "");

const setLoading = val => {
  emit("set-loading", val);
};

onBeforeMount(() => {
  emit("expand-class", { val: false, class: "" });
});
</script>

<style lang="scss"></style>
